import React, { useState } from 'react';

export default function ApplyDepositModal({ depositBalance, balanceDue, onConfirm, onCancel, applying }) {
  const defaultAmount = Math.min(depositBalance, balanceDue);
  const [amount, setAmount] = useState(defaultAmount.toFixed(2));
  const amountNum = parseFloat(amount) || 0;
  const valid = amountNum > 0 && amountNum <= depositBalance + 0.01;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--surface, #fff)', borderRadius: 14, padding: '32px 36px',
        minWidth: 360, boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        display: 'flex', flexDirection: 'column', gap: 18,
      }}>
        <div style={{ fontWeight: 700, fontSize: 17 }}>Apply Deposit to Invoice</div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          This client has <strong>LKR {depositBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong> unapplied
          in deposits. Choose how much to apply against this invoice's balance of LKR {balanceDue.toLocaleString(undefined, { minimumFractionDigits: 2 })}.
        </div>
        <div className="form-group">
          <label className="form-label">Amount to Apply (LKR)</label>
          <input
            type="number"
            step="0.01"
            className="form-input"
            value={amount}
            onChange={e => setAmount(e.target.value)}
            max={depositBalance}
            min={0}
          />
          {!valid && amount !== '' && (
            <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 4 }}>
              Amount must be between 0 and the available deposit balance.
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} className="btn btn-secondary" disabled={applying}>Cancel</button>
          <button
            onClick={() => onConfirm(amountNum)}
            className="btn btn-primary"
            disabled={!valid || applying}
          >
            {applying ? 'Applying…' : 'Apply Deposit'}
          </button>
        </div>
      </div>
    </div>
  );
}
